// extracted by mini-css-extract-plugin
module.exports = {"dndkitDropzone":"DnDKitDropzone_dndkitDropzone__1DCoV","isOver":"DnDKitDropzone_isOver__24KYf"};